import 'angular:locale/data:no';
import 'angular:locale/data:sv';
import 'angular:locale/data:nl';
import 'angular:locale/data:ms';
import 'angular:locale/data:ja';
import 'angular:locale/data:id';
import 'angular:locale/data:pt';
import 'angular:locale/data:ru';
import 'angular:locale/data:iw';
import 'angular:locale/data:zh-CN';
import 'angular:locale/data:ar';
import 'angular:locale/data:it';
import 'angular:locale/data:es';
import 'angular:locale/data:de';
import 'angular:locale/data:fr';
import 'angular:locale/data:en';
import './src/polyfills.ts';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
